import * as React from 'react'

function SvgCateEducation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M19.465 3c.533 0 .966.434.966.967v10.192h1.42v3.41h-7.363l1.382 3.364h-.821l-1.382-3.365h-1.362v3.365h-.76v-3.365h-1.36l-1.383 3.365h-.821l1.382-3.365H2v-3.41h1.42V3.968c0-.533.433-.967.966-.967zm1.626 11.919H2.76v1.89h18.331v-1.89zM19.465 3.76H4.386a.21.21 0 00-.206.207v10.192h15.49V3.967a.21.21 0 00-.206-.207zm-4.516 3.38c.772 0 1.296.136 1.699.44.455.338.686.856.686 1.538 0 .9-.37 1.401-.678 1.662-.418.348-1.082.532-1.918.532-.37 0-.706-.018-1.002-.052V7.216a8.97 8.97 0 011.213-.075zm-5.331.032v.616H8.445v3.48h-.774v-3.48H6.517v-.616h3.101zm3.167 0v.597h-1.676V8.86h1.58v.59h-1.58v1.22h1.764v.596h-2.54V7.172h2.452zm2.265.514c-.235 0-.38.022-.462.04l-.077.018v2.97l.077.018c.094.022.23.022.377.022.976 0 1.536-.585 1.536-1.604.003-.458-.124-.82-.379-1.077-.251-.253-.622-.387-1.072-.387z" />
    </svg>
  )
}

export default SvgCateEducation
